import { useCurrentProject } from 'api/queries/projects';
import { selectUserContext } from 'core/userContext';
import { NAVBAR_PROJECT_SETTINGS } from 'modules/nav/types';
import { createNavbarLinks } from 'modules/nav/utils';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { colors, Overline, spacing } from 'ui/theme';
import { camelCase } from 'utils/stringHelpers';
import { LinkContainer } from '../LinkContainer';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  padding: ${spacing.double} ${spacing.base};
  overflow-y: auto;
`;

const LinkSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

const StyledOverline = styled(Overline)`
  color: ${colors.textSecondary};
  padding-left: ${spacing.threeQuarter};
  padding-right: ${spacing.threeQuarter};
`;

export const NavigationMenu = () => {
  const userContext = useSelector(selectUserContext);
  const overrideDescription = { pageDescription: '' };
  const { projectSettings } = useCurrentProject();

  const formattedNavItems = createNavbarLinks(
    userContext,
    { [NAVBAR_PROJECT_SETTINGS.enableAnonUserTracking]: !!projectSettings?.enableAnonUserTracking },
    overrideDescription,
  );

  return (
    <Container>
      {formattedNavItems.map(({ dropdownOptions = [], header, shouldOpenInNewTab = false }) => {
        return (
          <LinkSection key={camelCase(header)}>
            <StyledOverline>{header}</StyledOverline>
            <LinkContainer
              dropdownOptions={dropdownOptions}
              path={''}
              shouldOpenInNewTab={shouldOpenInNewTab}
            />
          </LinkSection>
        );
      })}
    </Container>
  );
};
